import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { PlanType } from '../../components/enums/plan-type';
import { formatCurrency } from '../../components/formatters';
import useMsalApi from '../../components/use-msal-api';
import FsaTypeReview from './fsa-type-review';
import LifeReview from './life-review';

const FsaReview = ({modifiedSelections, unmodifiedSelections, enrollments, addDeduction}) => {
    const [isModified, setIsModified] = useState();
    const [deduction, setDeduction] = useState();
    const [fsaDetails, setFsaDetails] = useState();
    const [callApi] = useMsalApi();

    useEffect(() => {
        if(Array.isArray(enrollments))
            return;
        
        getFsaDetails();
        let medical = modifiedSelections.find(s => s.planType === PlanType.MedicalCareFsa)?.amount ?? 0;
        let dependent = modifiedSelections.find(s => s.planType === PlanType.DependentCareFsa)?.amount ?? 0;

        setDeduction(medical + dependent);
        addDeduction(medical+ dependent);
        
    }, []);


   const getFsaDetails = async () => {
    var params = {
        employeeNumber: enrollments.employee.id,
        effectiveDate: enrollments.effectiveDate,
        company : enrollments.employee.company,
        enrollmentsType : enrollments.enrollmentTypeId
    }
    var results = await callApi(`Fsa`, "POST", params);
    if(!results.error){
        setFsaDetails(results);
    }

}




    return ( 
        <div className="mb-4">
            <div className='grid grid-cols-2 items-center mb-2 w-96'>
                <div className='text-xl'>
                    <span className={isModified ? 'text-purple' : 'text-danger'}>FSA</span>
                </div>
                
                <div className="text-xs border-l border-solid border-slate-600 pl-8">Paycheck Deduction: {formatCurrency(deduction, 2)}</div>
            </div>

            <FsaTypeReview title="Medical FSA" modifiedSelections={modifiedSelections} unmodifiedSelections={unmodifiedSelections} planType={PlanType.MedicalCareFsa} setIsModified={setIsModified} fsaDetails={fsaDetails}  />
            <FsaTypeReview title="Depedent Care" modifiedSelections={modifiedSelections} unmodifiedSelections={unmodifiedSelections} planType={PlanType.DependentCareFsa} setIsModified={setIsModified} fsaDetails={fsaDetails} />
            <hr />
        </div>
     );
}
 
export default FsaReview;